/**
 * Task types for Kanban board
 */

export enum TaskStatus {
  TODO = 'todo',
  IN_PROGRESS = 'in_progress',
  TESTING = 'testing',
  DONE = 'done',
}

export enum TaskType {
  CASSETTE_INSTALLATION = 'cassette_installation',
  SPLICING = 'splicing',
  SPLITTER_INSTALLATION = 'splitter_installation',
  MEASUREMENT = 'measurement',
  PHOTO_DOCUMENTATION = 'photo_documentation',
  ONU_INSTALLATION = 'onu_installation',
  CABLE_INSTALLATION = 'cable_installation',
  OTHER = 'other',
}

export interface ChecklistItem {
  id: number;
  text: string;
  completed: boolean;
}

export interface Task {
  id: number;
  project_id: number;
  title: string;
  description?: string;
  task_type: TaskType;
  status: TaskStatus;
  pole_id?: number;
  pole_name?: string;
  cable_id?: number;
  cable_name?: string;
  onu_id?: number;
  onu_name?: string;
  assigned_to?: string;
  assigned_at?: string;
  priority: number; // 0=normal, 1=high, 2=urgent
  deadline?: string;
  progress: number; // 0-100
  checklist: ChecklistItem[];
  notes?: string;
  attachments: string[];
  created_at: string;
  updated_at: string;
  started_at?: string;
  completed_at?: string;
}

export interface TaskStats {
  total: number;
  todo: number;
  in_progress: number;
  testing: number;
  done: number;
  by_type: Record<string, number>;
  by_assignee: Record<string, number>;
  completion_rate: number;
}

export const TASK_TYPE_LABELS: Record<TaskType, string> = {
  [TaskType.CASSETTE_INSTALLATION]: '📦 Inštalácia kazety',
  [TaskType.SPLICING]: '🔗 Zváranie',
  [TaskType.SPLITTER_INSTALLATION]: '📡 Inštalácia splittra',
  [TaskType.MEASUREMENT]: '🔬 Meranie',
  [TaskType.PHOTO_DOCUMENTATION]: '📷 Fotodokumentácia',
  [TaskType.ONU_INSTALLATION]: '🔌 Inštalácia ONU',
  [TaskType.CABLE_INSTALLATION]: '📏 Inštalácia kábla',
  [TaskType.OTHER]: '📋 Iné',
};

export const TASK_STATUS_LABELS: Record<TaskStatus, string> = {
  [TaskStatus.TODO]: 'TODO',
  [TaskStatus.IN_PROGRESS]: 'IN PROGRESS',
  [TaskStatus.TESTING]: 'TESTING',
  [TaskStatus.DONE]: 'DONE',
};

export const PRIORITY_LABELS: Record<number, string> = {
  0: 'Normálna',
  1: 'Vysoká',
  2: 'Urgentná',
};

export const PRIORITY_COLORS: Record<number, string> = {
  0: '#64748b',
  1: '#f59e0b',
  2: '#ef4444',
};

